module.exports = __webpack_public_path__ + "f7c2b4b747b1a225eb8dee034134a1b0.eot";


//////////////////
// WEBPACK FOOTER
// ./~/ui/dist/fonts/fontawesome-webfont.eot
// module id = 477
// module chunks = 0